<!--视频源1-->
<template>
  <div class='container'>
     <video id="video"
      ref="dnvideo"
      class="dn-video-wh object-fit-contain video"
      :src="videoSrc"
      loop="loop"
      autoplay
      playsinline="true"
      controls="controls"
      x5-video-player-type="h5"
      x5-video-orientation="landscape"
      controlsList="nodownload  noplaybackrate"
      disablePictureInPicture
      v-bind:style="{width: width + 'px'}">
    </video>
  </div>
</template>

<script>
export default {
    name: 'vedioV1',
  //import引入的组件需要注入到对象中才能使用
  components: {},
    data() {
    //这里存放数据
      return {
        videoSrc:"https://dn-resource-a.obs.cn-south-1.myhuaweicloud.com/%E6%B0%B4%E7%AE%B1%E7%89%88/video%287%29%281%29.mp4",
        height: document.body.clientHeight,
        width: document.body.clientWidth,
        dataList:[
            {
                type:"A",
                vedio:"https://dn-resource-a.obs.cn-south-1.myhuaweicloud.com/%E6%B0%B4%E7%AE%B1%E7%89%88/video%287%29%281%29.mp4"
            },
            {
                type:"B",
                vedio:"https://dn-resource-a.obs.cn-south-1.myhuaweicloud.com/%E6%B0%B4%E7%AE%B1%E7%89%88/C5841.MP4"
            },
        ]
      };
    },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    $route (page) {

        
      }
  },
  //方法集合
  methods: {
    hideFooter() {
      const footer = document.querySelector('.dn-footer');
      const nav = document.querySelector('.dn-nav')
      if (footer) {
        footer.style.display = 'none';
      }
      if (nav) {
        nav.style.display = 'none';
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {

  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.hideFooter();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>


    /* .invisible {
  visibility: hidden !important;
  display: none !important;
} */


</style>


// WEBPACK FOOTER //
// src/components/vedioV1.vue